import { render, staticRenderFns } from "./upLoadcg.vue?vue&type=template&id=c94e3f06&"
import script from "./upLoadcg.vue?vue&type=script&lang=js&"
export * from "./upLoadcg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports